let str_slug = require('./global').str_slug;

  
  var defaults_opts = {
    'locale' : 'fr'
  }

// var fs = require('fs');
class MenuGenerator {
    constructor(opts) {
      this.options = Object.assign(defaults_opts, opts);
    }
    initialize() {
        // console.log('require', require('../../../../storage/app/jsonMenu/'+ this.options.locale +'_json_menu.json'))
        this.options.datas = require('../../../../public/app/jsonMenu/'+ this.options.locale +'_json_menu.json')
        // on gère ca en async , pour ne pas etre des brutes sur l'affichage ! Je peux gérer tous les niveaux comme ca !
        this.firstLevel().then((markup) => {
          let navbarMenu;
          // console.log('this', this)
          $('#navbarNav .navbar-nav').append(markup);
          this.secondLevel().then((genHtml) => {
            // console.log('genHtml', genHtml)
            // let navbarMenuItem = $('#navbarNav .nav-item').append(genHtml);
            $('#navbarNav .nav-item').each((index, el) => {
              $(el).append(genHtml[index])
            })
            this.lastLevel().then((arrHtml) => {
              // console.log('arrHtml menugenrator ', arrHtml)
              $('#navbarNav .nav-item .megamenu .right-col').each((index, el) => {
                $(el).append(arrHtml[index])
              })
              this.eventsMegamenu()
            })
          })
        });
        // console.log('datas', this.options.datas)
    }
    async firstLevel() {  
        
        let FirstLevelMarkup = '';
        for (let mere_id in this.options.datas) {
                let Mere_object_id = this.options.datas[mere_id];

                
                  FirstLevelMarkup += '<li class="nav-item dropdown dropdown-show-img">';
                  FirstLevelMarkup +=   '<a class="nav-link main-nav-link dropdown-toggle js-show-img"  href="#" id="navbarDropdownSubMenuLink" role="button" aria-haspopup="true" aria-expanded="false">' 
                        // {{$categorie['libelle'] }}
                  FirstLevelMarkup +=       Mere_object_id.libelle ;
                  FirstLevelMarkup +=   '</a>';
                  FirstLevelMarkup +=   '</li>';
                
                
        }
        return FirstLevelMarkup
    }
    async secondLevel() {
      
      let SecondLevelMarkupArr = new Array();
      let indexLoop = 0;
      Object.keys(this.options.datas).forEach((key) => { 
        // console.log('key desktop', key)       // console.log('mere_id', mere_id)
        let Mere_object_id = this.options.datas[key];
        let SecondLevelMarkup = '';

        //  if(parseInt(key) === Mere_object_id.id) {
            
              SecondLevelMarkup += '<div class="dropdown-menu" loop-index="'+ indexLoop +'" aria-labelledby="navbarDropdownSubMenuLink">';
              SecondLevelMarkup +=    '<a href="'+ Mere_object_id.url +'" class="title-megamenu-section dropdown-item-text"> '+ Lang._i('megamenu.allthe') +' '+ Mere_object_id.libelle +' </a>';
              SecondLevelMarkup +=    '<ul class="m-0 p-0 megamenu">';
              SecondLevelMarkup +=      '<li class="m-0 p-0 left-col">';
              SecondLevelMarkup +=        '<ul class="m-0 p-0 first-level">';

              for (let filles_id in Mere_object_id.filles) {
                  let Filles_object_id = Mere_object_id.filles[filles_id];
                  // Le Object Keys comme son nom l'indique ne retourne que les clés en array. et on count la dessus !
                  // console.log('length', Object.keys(Filles_object_id).length)
                  if(Object.keys(Filles_object_id).length > 0) {
                    
                    
                    SecondLevelMarkup +=  '<li data-trigger=".'+str_slug(Filles_object_id.libelle)+'" class="m-0 p-0 has-cat"><a class="dropdown-item" href="'+Filles_object_id.url+'">'+Filles_object_id.libelle+'<i class="material-icons">keyboard_arrow_right</i></a></li>';
                    
                  }
              }
              SecondLevelMarkup +=        '</ul>';
              SecondLevelMarkup +=        '</li>';
              SecondLevelMarkup +=        '<li class="m-0 p-0 right-col"></div>';
              SecondLevelMarkup +=        '</ul>';
              SecondLevelMarkup +=        '</div>';
              indexLoop++;
            
            
            SecondLevelMarkupArr.push(SecondLevelMarkup);
            
        //  }   
      })
      return SecondLevelMarkupArr
    }
    async lastLevel() {
      let LastLevelMarkupArr = new Array();
      
      for (let mere_id in this.options.datas) {
        let Mere_object_id = this.options.datas[mere_id];
        // console.log('menu generator id ', mere_id)

        let LastLevelMarkup = '';

          for (let filles_id in Mere_object_id.filles) {
              let Filles_object_id = this.options.datas[mere_id].filles[filles_id];
              
              
              LastLevelMarkup +=  '<ul class="second-level w-100 '+ str_slug(Filles_object_id.libelle) +'">';
              
            for (let fifille_id in Filles_object_id.filles) {
              let Fifilles_object_id = this.options.datas[mere_id].filles[filles_id].filles[fifille_id];
              
              
              LastLevelMarkup +=    '<li class="m-0 p-0 "><a class="dropdown-item" href="'+ Fifilles_object_id.url +'">'+ Fifilles_object_id.libelle +'</a></li>';

                  
            } 
              LastLevelMarkup +=  '</ul>';
              
          }
         
        LastLevelMarkupArr.push(LastLevelMarkup); 
        
    }
    return LastLevelMarkupArr;
  }
    eventsMegamenu() {
        $('.header-bottom #navbarNav .has-cat').each(function(i, el) {

            var $this = $(this);
            var local_dropdown_width = $this.parent().parent().outerWidth(true);
            var $width_parent = $this.parent().outerWidth(true);
            var $expand = $this.attr('data-trigger');
            var setHeight = 'auto';
            var timer;
        
            
        
            $this.click(function() {
              var $link = $this.children().first();
              window.location = $link.attr('href');
            })
            
            $(el).mouseover(function() {
              $this.children().first().addClass('active');
              $this.parent().parent().parent().parent().addClass('expanded')
              $('.second-level').not($expand).removeClass('active');
              $($expand).addClass('active');
              if($this.parent().parent().outerHeight(true) > $($expand).outerHeight(true)) {
                setHeight = $this.parent().parent().outerHeight(true) + 'px';
                $($expand).css({'height': setHeight})
                $this.parent().parent().css({'height': 'auto'});
              }
              else {
                setHeight = $($expand).outerHeight(true) + 'px';
                $this.parent().parent().css({'height': setHeight})
              }
            });
            $(el).mouseout(function(e) {
              // console.log('event', e)
              var $expand = $this.attr('data-trigger');
        
        
              if($(e.relatedTarget).hasClass($expand.substr(1)) == false) {
                $('.second-level').not('.second-level'+$expand).removeClass('active');
                $this.children().first().removeClass('active');
              
              }
              
            });
        
            
          })
        
        
          $('.megamenu').mouseleave(function() {
            $('.second-level').removeClass('active');
            $('.dropdown-show-img .dropdown-menu').removeClass('expanded');
          })
    }
}

export default MenuGenerator